import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Twitter, MessageCircle, Youtube } from 'lucide-react';
import SpotlightCard from './SpotlightCard';
import { Translations } from '../types';

interface AboutUsProps {
  t: Translations;
}

const iconMap = {
  linkedin: Linkedin,
  x: Twitter,
  discord: MessageCircle,
  youtube: Youtube
} as const;

export const AboutUs: React.FC<AboutUsProps> = ({ t }) => {
  return (
    <section className="about" aria-labelledby="about-heading" id="about">
      <div className="container about-container">
        <motion.div
          className="about-text"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="about-eyebrow">{t.about.subtitle}</p>
          <h2 id="about-heading" className="about-title">
            {t.about.title}
          </h2>
          <p className="about-mission">{t.about.mission}</p>
          <p className="about-description">{t.about.description}</p>
        </motion.div>

        <div className="about-links" role="list" aria-label={t.about.title}>
          {t.about.links.map((link, index) => {
            const Icon = iconMap[link.icon];
            return (
              <motion.a
                key={link.href}
                role="listitem"
                className="about-link-card"
                href={link.href}
                target="_blank"
                rel="noreferrer"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                viewport={{ once: true }}
              >
                <SpotlightCard className="about-link-card-inner" spotlightColor="rgba(0, 255, 157, 0.12)">
                  <div className="about-link-icon" aria-hidden="true">
                    <Icon size={20} />
                  </div>
                  <span className="about-link-label">{link.label}</span>
                </SpotlightCard>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
